import React from 'react';
import '../../assets/styles/Listado-Utiles.css';
// Importamos la imagen directamente
import bannerImage from '../../assets/images/images-featured-news/banner-utiles-escolares.webp';

export default function ListadoUtiles2026() {
  return (
    <>
      <div className="listado-utiles-banner" style={{ 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bannerImage})` 
      }}>
        <div className="banner-content">
          <h1>Listado de Útiles Escolares 2026</h1>
          <p>Todo lo que necesitas para comenzar el año escolar</p>
        </div>
      </div>      
      <div className="listado-utiles-container">
        <div className="curso-section notas">
          <h2>Notas Generales</h2>
          <ul>
            <li>Todos los útiles deben venir marcados con el nombre del estudiante</li>
            <li>Durante el año se solicitarán otros materiales, según se requiera</li>
            <li>Todos los materiales deben venir marcados al igual que la ropa de Educ. Física y uniforme</li>
            <li>Lo ideal es que todos los materiales sean de buena calidad</li>
          </ul>
        </div>

        <div className="curso-section preescolar">
          <h2>Play Group</h2>
          <ul>
            <li>1 Cuaderno college para comunicaciones con forro rojo</li>
            <li>1 Tijera punta roma</li>
            <li>1 Caja de lápices de colores jumbo</li>
            <li>1 Caja de lápices de cera gruesos de 12 colores</li>
            <li>1 Caja de plásticina 12 colores</li>
            <li>1 Caja DE plumones jumbo 12 colores</li>
            <li>2 Block de dibujo 99</li>
            <li>2 Frascos grandes de témpera (sugerencia: verde, blanca, piel, negro, rosado, rojo, amarillo, morada, naranja y azul)</li>
            <li>1 Acuarela</li>
            <li>1 Pincel grueso (número 12)</li>
            <li>4 Pliegos de papel kraft</li>
            <li>4 Pliegos de papel aconcagua</li>
            <li>1 Carpeta de cartulina española</li>
            <li>1 Carpeta de cartulina de color</li>
            <li>1 Set de goma eva adhesiva</li>
            <li>1 Set de goma eva escarchada adhesiva</li>
            <li>1 Paquete de papel lustre</li>
            <li>1 Cola fría</li>
            <li>1 Pegamento en barra</li>
            <li>1 Cinta de enmascarar</li>
            <li>1 Cinta de embalaje transparente</li>
            <li>1 Pliego de papel volantín</li>
            <li>1 Pliego papel crepé</li>
            <li>1 Caja tiza de color jumbo</li>
            <li>1 Paquete de palos baja lengua de colores</li>
            <li>1 Lana</li>
            <li>1 Frasco de escarcha</li>
            <li>1 Frasco de lentejuelas</li>
            <li>1 Masa para modelar</li>
            <li>1 Pliego papel celofán</li>
            <li>10 Barras de silicona (delgada)</li>
            <li>1 Punzón plástico</li>
            <li>1 Aguja punta roma de orificio grande</li>
            <li>1 Set de stickers</li>
            <li>10 Platos de cartón</li>
            <li>1 Caja de tempera sólida de 6 colores</li>
            <li>1 Bolsa de pompones</li>
            <li>1 Bolsa de limpiapipas</li>
            <li>1 Bolsa de cuentas para ensartar de orificio grandes</li>
            <li>1 Caja contenedora de 10 lts</li>
            <li>10 Pinzas de ropa</li>
            <li>Toalla con cinta para colgar</li>
          </ul>
        </div>

        <div className="curso-section preescolar">
          <h2>Pre-Kínder y Kínder</h2>
          <ul>
            <li>1 Cuaderno cuadro grande universitario 100 hjs. forro azul</li>
            <li>1 Cuaderno cuadro grande universitario 100 hjs. forro rojo</li>
            <li>1 Cuaderno chico para comunicaciones (forro rojo)</li>
            <li>4 Lápiz grafito</li>
            <li>1 Tijera</li>
            <li>1 Goma de borrar más sacapuntas</li>
            <li>2 Caja de lápices de colores largos buena calidad (1 semestral)</li>
            <li>2 Caja de lápices de cera de 12 colores (1 semestral)</li>
            <li>1 Caja de plásticina 12 colores</li>
            <li>1 Caja plumones de 12 colores</li>
            <li>1 Plumón permanente y 1 plumón pizarra</li>
            <li>2 Block de dibujo 99</li>
            <li>2 Frascos grandes de témpera (sugerencia: verde, blanca, piel, negro, rosado, rojo)</li>
            <li>1 Pincel grueso número 12 Paleta</li>
            <li>4 Pliegos de papel kraft</li>
            <li>2 Carpeta de cartulina de color</li>
            <li>1 Carpeta de goma Eva tradicional y 1 escarchada</li>
            <li>4 Paquetes de papel lustre</li>
            <li>1 Pliego de cartón forrado</li>
            <li>1 Cola fría (frasco)</li>
            <li>2 Pegamento en barra (Stick fix grandes)</li>
            <li>Cinta de enmascarar (1)</li>
            <li>Cinta de Embalaje Transparente (1)</li>
            <li>Papel volantín colores</li>
            <li>2 Pliegos papel crepé (color a elección)</li>
            <li>1 Silicona líquida (uso profesora)</li>
            <li>1 Caja tiza de color jumbo (gruesos) (chinos)</li>
            <li>Estuche grande marcado</li>
            <li>Toalla con elástico para colgar al cuello, vaso y cepillo dental unidos</li>
            <li>1 Paquete de palos baja lengua</li>
            <li>1 Ovillo de Lana</li>
            <li>1 Pliego papel de Regalo</li>
            <li>1 Frasco Goma Gliher</li>
            <li>Masa Funny Gunny</li>
            <li>3 Pliego papel Celofán</li>
            <li>1 Resma de hojas blancas</li>
            <li>10 Barras de silicona (Delgada)</li>
            <li>1 Punzón (Para niños Preescolares)</li>
            <li>Aguja Punta Roma de Orificio Grande</li>
            <li>1 Carpeta de cartulina Metálica</li>
            <li>1 Cajita de Chinches</li>
            <li>4 Pliegos cartulina diferente color</li>
          </ul>
          <h3>Textos:</h3>
          <ul>
            <li>Texto Caligrafix Nivel Pre-Kinder "Trazos y letras nº 1"; "Lógica y números nº 1"</li>
            <li>Texto Caligrafix Nivel Kinder "Trazos y letras nº 2"; "Lógica y números nº 2"</li>
          </ul>
        </div>

        <div className="curso-section primaria">
          <h2>1º a 4º Básico</h2>

          <h3>Lenguaje y Comunicación:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro rojo (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro rojo (solo segundo, tercero y cuarto año básico)</li>
            <li>1 Lápiz bicolor delgado</li>
            <li>1 Carpeta para pruebas</li>
            <li>1 Cuaderno de caligrafía</li>
            <li>Libro caligrafix (solo primero y segundo)</li>
          </ul>

          <h3>Educación Matemática:</h3>
          <ul>
            <li>1 Cuaderno College cuadro grande 100 hojas forro azul (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro azul (solo segundo, tercero y cuarto año básico)</li>
            <li>1 Regla de 30 cm</li>
            <li>1 Escuadra (excepto primer año)</li>
            <li>1 Transportador (excepto primer año)</li>
          </ul>

          <h3>Ciencias Naturales:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro verde (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro verde (solo segundo, tercero y cuarto año básico)</li>
          </ul>

          <h3>Ciencias Sociales:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro café (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro café (solo segundo, tercero y cuarto año básico)</li>
          </ul>

          <h3>Inglés:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro amarillo (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro amarillo (solo segundo, tercero y cuarto año básico)</li>
          </ul>

          <h3>Religión:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro celeste (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro celeste (solo segundo, tercero y cuarto año básico)</li>
          </ul>

          <h3>Orientación:</h3>
          <ul>
            <li>1 Cuaderno College cuadro chico 100 hojas forro blanco (solo primer año básico)</li>
            <li>1 Cuaderno universitario de cuadro 100 hojas forro blanco (solo segundo, tercero y cuarto año básico)</li>
          </ul>

          <h3>Educación Tecnológica:</h3>
          <ul>
            <li>1 Cuaderno de cuadro 100 hojas</li>
            <li>1 Carpeta de cartulina de colores</li>
            <li>1 Carpeta de papel lustre</li>
            <li>1 Carpeta de goma eva</li>
            <li>1 Tijera punta roma, 1 cola fría mediana</li>
            <li>1 Cinta de enmascarar para pegar trabajos</li>
            <li>1 Pegamento en barra grande</li>
            <li>1 Block chico</li>
            <li>1 Block Nº 99</li>
          </ul>

          <h3>Educación Artística:</h3>
          <ul>
            <li>1 Cuaderno de croquis</li>
            <li>1 Caja de lápices de colores</li>
            <li>1 Caja de lápices de cera</li>
            <li>1 Paquete de papel lustre de 10 X 10</li>
            <li>1 Caja de plasticina</li>
            <li>1 Caja de temperas</li>
            <li>Pinceles</li>
            <li>1 Paño para limpiar</li>
            <li>Vaso</li>
            <li>Caja plástica para guardar todos los materiales</li>
          </ul>

          <h3>Educación Física:</h3>
          <ul>
            <li>Buzo del colegio</li>
            <li>Polera gris</li>
            <li>Zapatillas blancas</li>
            <li>Short o calzas azules</li>
            <li>Materiales de aseo</li>
          </ul>

          <h3>En el estuche debe venir diariamente:</h3>
          <ul>
            <li>2 Lápiz mina</li>
            <li>1 Regla chica de 20 cm</li>
            <li>1 Stic fix grande</li>
            <li>1 Goma de borrar</li>
            <li>1 Tijera</li>
            <li>1 Destacador</li>
          </ul>
        </div>

        <div className="curso-section secundaria">
          <h2>5º a 8º Básico</h2>

          <h3>Lenguaje y Comunicación:</h3>
          <ul>
            <li>1 Cuaderno universitario 100 hojas líneas</li>
            <li>100 Hojas blancas</li>
          </ul>

          <h3>Educación Matemática:</h3>
          <ul>
            <li>1 Cuaderno Universitario 100 hojas</li>
            <li>Regla 30 cms</li>
            <li>1 Compás</li>
            <li>1 Escuadra</li>
            <li>1 Transportador</li>
            <li>1 Plumón de pizarra personal</li>
            <li>Lápiz grafito y goma de borrar</li>
            <li>1 Calculadora simple</li>
          </ul>

          <h3>Inglés:</h3>
          <ul>
            <li>1 Cuaderno universitario 100 hojas cuadro grande</li>
          </ul>

          <h3>Ciencias Naturales:</h3>
          <ul>
            <li>1 Cuaderno universitario 100 hojas cuadro grande</li>
          </ul>

          <h3>Ciencias Sociales:</h3>
          <ul>
            <li>1 Cuaderno universitario 100 hojas cuadro grande</li>
            <li>1 Carpeta para trabajos</li>
          </ul>

          <h3>Música:</h3>
          <ul>
            <li>1 Cuaderno de media pauta</li>
          </ul>

          <h3>Religión:</h3>
          <ul>
            <li>1 Cuaderno chico 40 hojas</li>
          </ul>

          <h3>Tecnología:</h3>
          <ul>
            <li>1 Cuaderno chico de 40 hojas</li>
          </ul>

          <h3>Educación Artística:</h3>
          <ul>
            <li>1 Cuaderno de croquis</li>
            <li>2 Block de dibujo Nº99</li>
            <li>1 Caja de lápices de colores</li>
            <li>1 Caja de plumones</li>
            <li>1 Paquete de papel lustre de 10x10</li>
          </ul>

          <h3>Educación Física:</h3>
          <ul>
            <li>Buzo del colegio</li>
            <li>Polera azul cuello rojo</li>
            <li>Zapatillas blancas</li>
            <li>Short o calzas azules</li>
            <li>Materiales de aseo</li>
          </ul>

          <h3>En el estuche debe venir diariamente:</h3>
          <ul>
            <li>2 Lápiz mina</li>
            <li>1 Regla chica de 20 cm</li>
            <li>1 Stic fix grande</li>
            <li>1 Goma de borrar</li>
            <li>1 Tijera punta redonda</li>
            <li>1 Destacador</li>
          </ul>
        </div>
      </div>
    </>
  );
}